// extracted by mini-css-extract-plugin
module.exports = {"name":"\"less\"","themeColor":"#3B95F3"};